module.exports = __webpack_public_path__ + "static/media/gruporv.128d2739.svg";